import * as React from "react";
import type { SVGProps } from "react";
const SvgMarinaIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 28 28"
    {...props}
  >
    <path
      fill="#858585"
      d="M14 7a2.333 2.333 0 1 1 0-4.667A2.333 2.333 0 0 1 14 7m0-1.167A1.167 1.167 0 1 0 14 3.5a1.167 1.167 0 0 0 0 2.333"
    />
    <path fill="#858585" d="M13.417 6.417h1.166v18.666h-1.166z" />
    <path
      fill="#858585"
      d="M4.667 16.917a.583.583 0 1 1 1.166 0c0 4.978 3.184 7.583 8.167 7.583s8.167-2.605 8.167-7.583a.583.583 0 0 1 1.166 0c0 5.68-3.751 8.75-9.333 8.75s-9.333-3.07-9.333-8.75"
    />
    <path
      fill="#858585"
      d="M3.912 19.08a.583.583 0 1 1-.825-.826l1.75-1.75a.58.58 0 0 1 .674-.11l2.333 1.168a.583.583 0 0 1-.522 1.043l-1.957-.979zM24.087 19.08a.583.583 0 0 0 .825-.826l-1.75-1.75a.58.58 0 0 0-.673-.11l-2.333 1.168a.583.583 0 0 0 .521 1.043l1.958-.979zM9.917 10.5a.583.583 0 1 1 0-1.167h8.166a.583.583 0 0 1 0 1.167z"
    />
  </svg>
);
export default SvgMarinaIcon;
